module.exports = __webpack_public_path__ + "static/media/nav_cp_bqw_bg.198935cb.png";